import { clerkCaller } from '@services/apiCaller';
import { CatchErr } from '@utils/types';
import queryString from 'query-string';

const ClerkAuth = {
  async signout(): Promise<void> {
    await clerkCaller().post(
      '/v1/session',
      queryString.stringify({
        _method: 'DELETE',
      }),
    );
  },

  async finalizeSSO(samlAttemptCode: string): Promise<void> {
    try {
      // Registered accounts will sign in with this call
      await clerkCaller().post(
        '/v1/session/sign_in_attempt/attempt_factor_one',
        queryString.stringify({
          strategy: 'saml',
          code: samlAttemptCode,
        }),
      );
    } catch (err: CatchErr) {
      // Unregistered accounts have an extra step to sign up
      await clerkCaller().post(
        '/v1/session/sign_up_attempt',
        queryString.stringify({
          _method: 'PUT',
          account_transfer_token: err.response.data.error.transfer_code,
        }),
      );
    }
  },

  async loginWithSSO(email: string): Promise<void> {
    await clerkCaller().post(
      '/v1/session/sign_in_attempt',
      queryString.stringify({
        _method: 'PUT',
        identifier: email,
      }),
    );
    const resp2 = await clerkCaller().post(
      '/v1/session/sign_in_attempt/prepare_factor_one',
      queryString.stringify({
        strategy: 'saml',
      }),
    );

    window.rudderanalytics.track('User Logged In');

    window.location =
      resp2.data.response.factor_one_verification.external_verification_redirect_url;
  },
};

export default ClerkAuth;
